const accordian = {
    accordian: document.querySelectorAll('.jsAccordian') as NodeListOf<HTMLElement>,
    tabWrap : document.getElementById('tabWrap') as HTMLElement,
    tabHeight: 0,

    init() {
        this.toggle();      
    },

    toggle() {
        this.accordian.forEach((item) => {       
            const parent = item.parentElement as HTMLElement;
            const sibiling =  item.nextElementSibling as HTMLElement;
            const width = item.dataset.width ? item.dataset.width : '999999';
            if (window.innerWidth < parseInt(width)) {
                this.toggleHeight(item, parent, sibiling); 
            } else {               
                if(item.dataset.tab === 'true') {
                    this.toggleTab(item, sibiling);
                }
            }
           
        });

    },
    toggleHeight(item: HTMLElement, parent: HTMLElement, sibiling: HTMLElement) {
            const sibilingHeight = sibiling.offsetHeight;
            const height = item.offsetHeight;

            if (item.dataset.open === 'true') {
                parent.style.maxHeight = height + sibilingHeight +  'px';
                item.classList.add('activeClass');
            }          

            item.addEventListener('click', (e) => {
                e.preventDefault();

                if (item.dataset.open === 'false') {

                    item.dataset.open = 'true';
                    parent.style.maxHeight = height + sibilingHeight + 1 + 'px';
                    item.classList.add('activeClass');
                } else {
                    item.dataset.open = 'false';
                    parent.style.maxHeight = height + 1 + 'px';
                    item.classList.remove('activeClass');
                }
            });       
    },

    toggleTab(item: HTMLElement, sibiling: HTMLElement){
        const sibilingHeight = sibiling.offsetHeight;
        const height = item.offsetHeight;   
     
        if(this.tabHeight < sibilingHeight) {
            this.tabHeight = sibilingHeight ;
            this.tabWrap.style.height = height + sibilingHeight + 1 + 'px';
        }
        if (item.dataset.opentab === 'true') {
            sibiling.classList.add('activeClass');
            item.classList.add('activeClass');
        } 

        item.addEventListener('click', (e) => {
            e.preventDefault();
            this.accordian.forEach((item) => {
                const sibiling =  item.nextElementSibling as HTMLElement;
                item.dataset.opentab = 'false';
                sibiling.classList.remove('activeClass');
                item.classList.remove('activeClass');
            });
    
            if (item.dataset.opentab === 'false') {
                item.dataset.opentab = 'true';
                sibiling.classList.add('activeClass');
                item.classList.add('activeClass');
            } else {
                item.dataset.opentab = 'false';
                sibiling.classList.remove('activeClass');
                item.classList.remove('activeClass');
            }
        }); 
  
    }
}

export default accordian;